import styled from 'styled-components';
interface Colors {
  border: string;
  image?: string;
}

export const Container = styled.div`
  &.stepper {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
  }
`;

export const Step = styled.div<Colors>`
  display: flex;
  align-items: center;
  flex-grow: 1;
  cursor: pointer;

  .step__coin {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 60px;
    height: 60px;

    border: 2px solid ${({ border }) => border && `${border}`};
    border-radius: 30px;

    background: no-repeat center;
    background-size: 30px;
    background-image: url(${({ image }) => image && `${image}`});
  }
`;

export const Track = styled.div<Colors>`
  &.track {
    width: 35px;

    border-bottom: 2px solid ${({ border }) => border && `${border}`};
  }
`;
